import { AxiosHttpClient } from "../httpClient/axios-http-client.service";

export type Totals = {
  total: {
    value: number
    data_type: string
  }
  items: [
    {
      label: string
      result: [
        {
          key: string
          value: number
          data_type: string
        },
        {
          key: string
          value: number
          data_type: string
        },
        {
          key: string
          value: number
          data_type: string
        }
      ]
    }
  ]
}

export type PresentPros = {
  year: number
  quarter: number
  number: number
  unit_ids: string[]
}

export type QuestionPros = {
  question_key: string
  unit_ids?: string[]
  year: number
  quarter: number
}

export type MissionaryReportParams = {
  year: number
  quarter: number
  lesson_number?: number
  unit_ids?: string[]
}

export type MissionaryReportUnit = {
  unit_name: string
  students_present: number
  students_enrolled: number
  studied_bible_and_lesson: number
  participated_small_group: number
  gave_bible_study: number
  lead_to_baptism: number
  total_lessons: number
}

export type MissionaryReport = {
  units: MissionaryReportUnit[]
}

export class BiService extends AxiosHttpClient {
  public static async getPresentMissingRelation(params: PresentPros): Promise<Totals> {
    const { data: { data } } = await this.axiosHttpClient.post(`/bi/present-missing-relation`, params);
    return data;
  }

  public static async getQuestionAnswerIndex(params: QuestionPros): Promise<Totals> {
    const { data: { data } } = await this.axiosHttpClient.post(`/bi/question-answer-index`, params);
    return data;
  }

  public static async getMissionaryActivitiesReport(params: MissionaryReportParams): Promise<MissionaryReport> {
    const { data: { data } } = await this.axiosHttpClient.post(`/bi/missionary-activities-report`, params);
    return data;
  }
}